import { render, staticRenderFns } from "./homeCard.vue?vue&type=template&id=64636760&scoped=true&"
import script from "./homeCard.vue?vue&type=script&lang=js&"
export * from "./homeCard.vue?vue&type=script&lang=js&"
import style0 from "./homeCard.vue?vue&type=style&index=0&id=64636760&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64636760",
  null
  
)

export default component.exports